/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Mijn PiE BFF
 * OpenAPI spec version: 1.0
 */

export type UsageClassification = typeof UsageClassification[keyof typeof UsageClassification];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UsageClassification = {
  None: 'None',
  SmallConsumption: 'SmallConsumption',
  LargeConsumption: 'LargeConsumption',
} as const;
